import { render, staticRenderFns } from "./PlantList.vue?vue&type=template&id=610f74d0&scoped=true&"
import script from "./PlantList.vue?vue&type=script&lang=js&"
export * from "./PlantList.vue?vue&type=script&lang=js&"
import style0 from "./PlantList.vue?vue&type=style&index=0&id=610f74d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f74d0",
  null
  
)

export default component.exports